// extracted by mini-css-extract-plugin
export var leftAlign = "_21-2";
export var popper = "_21-0";
export var subtitle = "_21-1";